export default "__VITE_PUBLIC_ASSET__f76d6760__"